var modules_997b7aad = {"container":"Logo_module_container__9fe877b5","important":"Logo_module_important__9fe877b5","text-wrapper":"Logo_module_textWrapper__9fe877b5"};
import "../../../assets/esm/components/Logo/src/Logo~BvU6MKTQ.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
